import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { combineLatest, forkJoin } from 'rxjs';
import { SalesModuleApiSuffixModels } from '../../../../../modules/sales/shared/utils/sales-module.enums';
import { AppState } from '../../../../../reducers';
import { CrudService } from '../../../../../shared/services/crud.service';
import { RxjsService } from '../../../../../shared/services/rxjs.services';
import { ModulesBasedApiSuffix } from '../../../../../shared/utils/enums.utils';
import { prepareRequiredHttpParams, setRequiredValidator } from '../../../../../shared/utils/functions.utils';
import { IApplicationResponse } from '../../../../../shared/utils/interfaces.utils';
import { formConfigs } from '../../../../../shared/utils/variables.utils';
import { loggedInUserData } from '../../../../others/auth.selectors';
@Component({
    selector: 'app-appointment-escalation',
    templateUrl: './appointment-escalation-pop-up.component.html'
})

export class AppointmentEscalationPopupComponent implements OnInit {
    formConfigs = formConfigs;
    reactiveFormGroup: FormGroup;
    escalationReasons = [];
    escalationTo = [];
    isFormSubmitted = false;
    appointmentDateTimeModel = '';
    data;

    constructor(
        private crudService: CrudService,
        public ref: DynamicDialogRef, public config: DynamicDialogConfig,
        private formBuilder: FormBuilder,
        private rxjsService: RxjsService, private store: Store<AppState>) {
        this.data = config?.data;
    }

    ngOnInit(): void {
        this.combineLatestNgrxStoreData();
        this.createQuotationForm();
        this.getForkJoinRequests();
        this.appointmentDateTimeModel = this.data?.appointmentDate + " " + this.data?.appointmentTime;
    }

    combineLatestNgrxStoreData() {
        combineLatest([this.store.select(loggedInUserData)]).subscribe((response) => {
            if (!response[0]) {
                this.dialogClose();
            }
        });
    }

    getForkJoinRequests(): void {
        forkJoin([this.getEscalationTo(), this.getEscalationReasons()]).subscribe((resp: IApplicationResponse[]) => {
            resp.forEach((res: IApplicationResponse, ix: number) => {
                if (res.isSuccess && res.statusCode === 200) {
                    switch (ix) {
                        case 0:
                            this.escalationTo = res.resources;
                            break;
                        case 1:
                            this.escalationReasons = res.resources;
                            break;
                    }
                }
            });
            this.rxjsService.setPopupLoaderProperty(false);
        });
    }

    getEscalationTo() {
        return this.crudService.get(
            ModulesBasedApiSuffix.SALES,
            SalesModuleApiSuffixModels.APPOINTMENT_ESCALATION_ROLE_LEVELS, undefined, false, prepareRequiredHttpParams({
                leadId: this.data?.leadId
            }));
    }

    getEscalationReasons() {
        return this.crudService.get(
            ModulesBasedApiSuffix.SALES,
            SalesModuleApiSuffixModels.SELLER_APPOINTMENT_ESCALATION_REASONS_LIST, undefined, false, null);
    }

    createQuotationForm(): void {
        let model = {
            escalationUserId: '', escalationReasonId: '', notes: ''
        };
        this.reactiveFormGroup = this.formBuilder.group({});
        Object.keys(model).forEach((key) => {
            this.reactiveFormGroup.addControl(key,
                new FormControl(model[key]));
        });
        this.reactiveFormGroup = setRequiredValidator(this.reactiveFormGroup, ["escalationUserId", "escalationReasonId"]);
    }

    onSubmit(): void {
        this.isFormSubmitted = true;
        if (this.reactiveFormGroup.invalid) return;
        this.reactiveFormGroup.value.appointmentDateTime = this.appointmentDateTimeModel;
        this.reactiveFormGroup.value.leadId = this.data?.leadId;
        this.reactiveFormGroup.value.createdUserId = this.data?.createdUserId;
        this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.ESCALATION_APPOINTMENTS, this.reactiveFormGroup.value).subscribe((response) => {
            if (response.isSuccess && response.statusCode === 200) {
                this.ref.close(true);
            }
        });
    }

    dialogClose(): void {
        this.ref.close(false);
    }

    ngOnDestroy(): void {
        this.rxjsService.setDialogOpenProperty(false);
    }
}
